import React, { useEffect } from 'react'
import { HomeCatalogos } from '../components/HomeCatalogos'
import  HomeCategorias  from '../components/HomeCategorias'
import { HomeNosotros } from '../components/HomeNosotros'
import HomeProductosMuestras from '../components/HomeProductosMuestras'
import  HomeSliderPrincipal  from '../components/HomeSliderPrincipal'
import { HomeSliderSecundario } from '../components/HomeSliderSecundario'
import { CambiarColoresPrincipales } from '../hooks/config'
import { scrollBodyTop } from '../hooks/scrollPosition'
const HomePage = () => {

    useEffect(() => {
        scrollBodyTop()
        CambiarColoresPrincipales('fansa')
    }, [])

    // componentWillUnmount using useEffect
    useEffect(() => {
        return () => {
          CambiarColoresPrincipales()
        }
    }, [])

    return (
        <div style={{ width: "100%" }}>
            <HomeSliderPrincipal />
            <HomeSliderSecundario />
            <HomeCategorias />
            <HomeNosotros />
            {/* <HomeProductosMuestras /> */}
            <HomeCatalogos />
        </div>
    )
}

export default HomePage